<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="authorsnote">
<div class="chapterHead">
<h2 class="chapterTitle">Author’s Note</h2>
</div>
<p class="para">A few names in the book have Roman numerals attached to them. The rule of “numbering” officers in the Russian army originated because there were often several officers with the same last names, i.e., four Tuchkovs, 12 Ilovaiskys, and 18 Grekovs. Therefore, numbers were attached to their last names to distinguish them: Tuchkov I, Ilovaisky IX, and Grekov XVIII. Dates in original Russian documents are tied to the Julian calendar, which was used in Russia until the October Revolution of 1917. To convert a date to the modern calendar, I added 11 days to dates prior to 1 March 1800, and 12 days to dates after 1 March 1800.</p>
<p class="para">Tables are based on works consulted during research and illustrate different aspects of the officer corps. The most important of them are Liubomir Besrovny’s two classical studies on the Russian army in the 18th and 19th centuries, and Dmitry Tselorungo’s excellent work <em class="italic">Ofitsery Russkoi Armii—uchastniki Borodinskogo Srazhenia</em>. I also used data from my research to verify and complement these studies. The analytical tables are primarily based upon data collected on 2,074 officers who served with the 1st and 2nd Western Armies in 1812.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// therussian_authorsnote.vue?33c3abb3